import { render } from "./TeamGallery.vue?vue&type=template&id=471fc550&scoped=true"
import script from "./TeamGallery.vue?vue&type=script&lang=js"
export * from "./TeamGallery.vue?vue&type=script&lang=js"

import "./TeamGallery.vue?vue&type=style&index=0&id=471fc550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471fc550"]])

export default __exports__